const actions = {
    SET_DATA: 'users/SET_DATA',
    GET_DATA: 'users/GET_DATA',
};

export default actions
